module.exports = __webpack_public_path__ + "media/images/hero/hero1-house-wall-right-6f2b3554f74a7e23cb3c91d42b87284d.svg";